<template>
  <div class="sourceRecord">
    <template v-if="sourceData.length != 0">
      <template v-if="processID == '5'">
        <sourceRecordHead
          :userSelectCode="userSelectCode"
          :workID="workID"
          :processID="processID"
          :sourceData="sourceData"
          :modStatus="modStatus"
        />
      </template>
      <template v-if="processID == '6'">
        <sourceRecordThread
          :userSelectCode="userSelectCode"
          :workID="workID"
          :processID="processID"
          :sourceData="sourceData"
          :modStatus="modStatus"
        />
      </template>
      <template v-if="processID == '7'">
        <sourceRecordHeat
          :userSelectCode="userSelectCode"
          :workID="workID"
          :processID="processID"
          :sourceData="sourceData"
          :modStatus="modStatus"
        />
      </template>
    </template>
  </div>
</template>

<script>
import sourceRecordHead from "@/components/orderManagement/sourceRecord/sourceRecordHead.vue";
import sourceRecordThread from "@/components/orderManagement/sourceRecord/sourceRecordThread.vue";
import sourceRecordHeat from "@/components/orderManagement/sourceRecord/sourceRecordHeat.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "sourceRecord",
  props: {
    userSelectCode: {
      type: Number,
      default: 0
    },
    workID: {
      type: String
    },
    processID: {
      type: String
    },
    sourceData: {
      type: Array,
      default: [
        {
          unit_actual_weight: "",
          workorderItem: [],
          wireItem: [],
          runcardItem: [],
          totalProduceTimeItem: []
        }
      ]
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {},
  components: {
    sourceRecordHead,
    sourceRecordThread,
    sourceRecordHeat
  },
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    ...mapActions({}),
    onClick() {}
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.sourceRecord-input-disabled {
  background: transparent;
  color: #000;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/sourceRecord.vue